"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Dateien service.
* @module api/DateienApi
* @version 0.0.1
*/
class DateienApi {
  /**
  * Constructs a new DateienApi. 
  * @alias module:api/DateienApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createUploadFileUploadfilePost operation.
   * @callback module:api/DateienApi~createUploadFileUploadfilePostCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Upload File
   * @param {File} file 
   * @param {Object} opts Optional parameters
   * @param {Number} [feuerwehrId = 0)] Optionale FeuerwehrID um ezu übreprüfen ob der Nutzer ein Verwalter ist.
   * @param {module:api/DateienApi~createUploadFileUploadfilePostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  createUploadFileUploadfilePost(file, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'file' is set
    if (file === undefined || file === null) {
      throw new Error("Missing the required parameter 'file' when calling createUploadFileUploadfilePost");
    }
    let pathParams = {};
    let queryParams = {
      'feuerwehr_id': opts['feuerwehrId']
    };
    let headerParams = {};
    let formParams = {
      'file': file
    };
    let authNames = ['JWTBearer'];
    let contentTypes = ['multipart/form-data'];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/uploadfile/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = DateienApi;